const BUCKETS = ['Current', '30-60 Days', '60-90 Days', '90+ Days', 'Total'];
const SUB_COLS = ['net', 'misc', 'buf'];

const csvCell = (value) => {
  if (value == null) return '';
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const getVal = (arItems, bucketKey, field) => {
  const item = arItems?.find((x) => x.description === bucketKey);
  return item?.[field] ?? 0;
};

export const exportSubAgencyARCsv = (subAgencies, totals, agencyId) => {
  // Header row
  const headers = ['Agency Name', 'Agency ID'];
  for (const bucket of BUCKETS) {
    for (const col of SUB_COLS) {
      headers.push(`${bucket} ${col.charAt(0).toUpperCase() + col.slice(1)}`);
    }
  }

  const rows = [headers.map(csvCell).join(',')];

  // Data rows
  for (const agency of subAgencies) {
    const row = [csvCell(agency.agencyName), agency.agencyId];
    for (const bucket of BUCKETS) {
      for (const col of SUB_COLS) {
        row.push(getVal(agency.accountsReceivable, bucket, col));
      }
    }
    rows.push(row.join(','));
  }

  // Totals row
  if (totals) {
    const row = [csvCell(totals.agencyName || 'Total all agencies'), totals.agencyId || ''];
    for (const bucket of BUCKETS) {
      for (const col of SUB_COLS) {
        row.push(getVal(totals.accountsReceivable, bucket, col));
      }
    }
    rows.push(row.join(','));
  }

  const csv = rows.join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const date = new Date().toISOString().slice(0, 10);
  const link = document.createElement('a');
  link.href = url;
  link.download = `sub-agency-ar-${agencyId}-${date}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};
